import { createSlice } from "@reduxjs/toolkit"

export const customerListSlice = createSlice({
	name: "customerList",
	initialState: {
		customer: "",
		errors: [],
	},

	reducers: {
        getCustomer: (state, action) => {
           
			state.customer = action.payload
		},
		getCustomerList: (state, action) => {
		 
			state.customer = action.payload
		},
		getErrors: (state, action) => {
           
			state.errors = action.payload
		},
	},
})
export const {getCustomer, getCustomerList, getErrors} = customerListSlice.actions

export default customerListSlice.reducer
